import * as types from './mutation-types'

export default {
    [types.LOAD_TICKET_TYPES](state, data) {
        state.types = data
    }
}
